const API_URL = process.env.REACT_APP_API_URL

if (!API_URL) {
  throw new Error('REACT_APP_API_URL required');
}

export {
  API_URL
};
